import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import './sign-in61.css'

interface SignIn61Props {
  rootClassName?: string;
  imageAlt?: string;
  text?: React.ReactElement;
  imageSrc?: string;
  image1Src?: string;
  action1?: React.ReactElement;
  image1Alt?: string;
  imageSrc1?: string;
  imageAlt1?: string;
  heading1?: React.ReactElement;
  onLogin?: (username: string, password: string) => void;
  error?: string;
  loading?: boolean;
}

const SignIn61: React.FC<SignIn61Props> = (props = defaultProps) => {
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (props.onLogin) {
      props.onLogin(username, password)
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className={`sign-in61-container1 ${props.rootClassName} `}>
      <div className="sign-in61-max-width thq-section-max-width">
        <div className="sign-in61-container2">
          <img
            alt={props.image1Alt}
            src={props.image1Src}
            className="sign-in61-sign-up-image thq-img-ratio-4-6"
          />
        </div>
        <div className="sign-in61-container3">
          <Link to="/" className="sign-in61-navlink">
            <img
              alt={props.imageAlt}
              src={props.imageSrc}
              className="sign-in61-image1 hover-effect-logo"
            />
          </Link>
          <div className="sign-in61-form-root thq-section-padding">
            <div className="sign-in61-form1">
              <h2 className="sign-in61-text1 thq-heading-2">
                {props.heading1 ?? (
                  <Fragment>
                    <span className="sign-in61-text8">Bienvenido</span>
                  </Fragment>
                )}
              </h2>
              {props.error && <div className="sign-in61-error">{props.error}</div>}
              <form className="sign-in61-form2" onSubmit={handleSubmit}>
                <div className="sign-in61-ingreso-usuario">
                  <input
                    type="text"
                    id="thq-sign-in-6-email"
                    required
                    placeholder=""
                    className="sign-in61-textinput1 thq-body-large thq-input"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <label
                    htmlFor="thq-sign-in-6-email"
                    className="thq-body-large"
                  >
                    Usuario
                  </label>
                </div>
                <div className="sign-in61-password">
                  <div className="sign-in61-textfield">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="thq-sign-in-6-password"
                      required
                      placeholder=""
                      className="sign-in61-textinput2 thq-body-large thq-input"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <label
                      htmlFor="thq-sign-in-6-password"
                      className="thq-body-large"
                    >
                      Contraseña
                    </label>
                    <div className="sign-in61-container4">
                      <div 
                        className="sign-in61-hide-password"
                        onClick={togglePasswordVisibility}
                        style={{ cursor: 'pointer' }}
                      >
                        <svg
                          viewBox="0 0 1024 1024"
                          className="sign-in61-icon1"
                        >
                          {showPassword ? (
                            // Eye icon with slash (hide password)
                            <path d="M317.143 762.857l44.571-80.571c-66.286-48-105.714-125.143-105.714-206.857 0-45.143 12-89.714 34.857-128.571-89.143 45.714-163.429 117.714-217.714 201.714 59.429 92 143.429 169.143 244 214.286zM539.429 329.143c0-14.857-12.571-27.429-27.429-27.429-95.429 0-173.714 78.286-173.714 173.714 0 14.857 12.571 27.429 27.429 27.429s27.429-12.571 27.429-27.429c0-65.714 53.714-118.857 118.857-118.857 14.857 0 27.429-12.571 27.429-27.429zM746.857 220c0 1.143 0 4-0.571 5.143-120.571 215.429-240 432-360.571 647.429l-28 50.857c-3.429 5.714-9.714 9.143-16 9.143-10.286 0-64.571-33.143-76.571-40-5.714-3.429-9.143-9.143-9.143-16 0-9.143 19.429-40 25.143-49.714-110.857-50.286-204-136-269.714-238.857-7.429-11.429-11.429-25.143-11.429-39.429 0-13.714 4-28 11.429-39.429 113.143-173.714 289.714-289.714 500.571-289.714 34.286 0 69.143 3.429 102.857 9.714l30.857-55.429c3.429-5.714 9.143-9.143 16-9.143 10.286 0 64 33.143 76 40 5.714 3.429 9.143 9.143 9.143 15.429zM768 475.429c0 106.286-65.714 201.143-164.571 238.857l160-286.857c2.857 16 4.571 32 4.571 48zM1024 548.571c0 14.857-4 26.857-11.429 39.429-17.714 29.143-40 57.143-62.286 82.857-112 128.571-266.286 206.857-438.286 206.857l42.286-75.429c166.286-14.286 307.429-115.429 396.571-253.714-42.286-65.714-96.571-123.429-161.143-168l36-64c70.857 47.429 142.286 118.857 186.857 192.571 7.429 12.571 11.429 24.571 11.429 39.429z"></path>
                          ) : (
                            // Eye icon (show password)
                            <path d="M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z"></path>
                          )}
                        </svg>
                        <span className="thq-body-small">
                          <span className="sign-in61-text6">
                            {showPassword ? "Esconder" : "Mostrar"}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <a
                    href="https://forjadecodigo.com/contactanos"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="sign-in61-link1 thq-body-small"
                  >
                    ¿Olvido la contraseña?
                  </a>
                </div>
                <button 
                  type="submit" 
                  className={`sign-in61-button thq-button-filled ${props.loading ? 'loading' : ''}`}
                  disabled={props.loading}
                >
                  {props.loading ? (
                    <div className="button-loading-container">
                      <div className="loading-dots">
                        <div className="loading-dot"></div>
                        <div className="loading-dot"></div>
                        <div className="loading-dot"></div>
                      </div>
                      <span>Cargando</span>
                    </div>
                  ) : (
                    <span className="sign-in61-text5 thq-body-small">
                      {props.action1 ?? (
                        <Fragment>
                          <span className="sign-in61-text7">Ingresar</span>
                        </Fragment>
                      )}
                    </span>
                  )}
                </button>
              </form>
            </div>
            <a
              href="https://forjadecodigo.com"
              target="_blank"
              rel="noreferrer noopener"
              className="sign-in61-link2"
            >
              <img
                alt={props.imageAlt1}
                src={props.imageSrc1}
                className="sign-in61-image2"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

const defaultProps: SignIn61Props = {
  rootClassName: '',
  imageAlt: 'image',
  text: undefined,
  imageSrc: '/logoganando1.svg',
  image1Src: '/siare-1500w.jpg',
  action1: undefined,
  image1Alt: 'SignUp Image',
  imageSrc1: '/forjalogovector-700h.png',
  imageAlt1: 'image',
  heading1: undefined,
  onLogin: undefined,
  error: '',
  loading: false,
}

SignIn61.propTypes = {
  rootClassName: PropTypes.string,
  imageAlt: PropTypes.string,
  text: PropTypes.element,
  imageSrc: PropTypes.string,
  image1Src: PropTypes.string,
  action1: PropTypes.element,
  image1Alt: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageAlt1: PropTypes.string,
  heading1: PropTypes.element,
  onLogin: PropTypes.func,
  error: PropTypes.string,
  loading: PropTypes.bool,
}

export default SignIn61
